// Informations de contact centralisées (utilisées par Contact, Footer, etc.)
export const contact = {
  firstName: "Pauline",
  lastName: "Limousin",
  phone: "06 35 21 23 02",
  phoneHref: "tel:+33635212302",
  email: "paulinelimous1@gmail.com",
  studioAddress: "20 rue de l'Issel, 59143 Millam",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=20+rue+de+l'Issel+59143+Millam",
  zone: "le Dunkerquois, le Calaisis, l'Audomarois et la métropole lilloise",
  siren: "904300100",
};

export const socials = [
  {
    name: "Instagram",
    icon: "fab fa-instagram",
    url: "https://www.instagram.com/paulinelimousin/",
  },
  {
    name: "Facebook",
    icon: "fab fa-facebook",
    url: "https://www.facebook.com/paulinelimous1/",
  },
  {
    name: "LinkedIn",
    icon: "fab fa-linkedin",
    url: "https://www.linkedin.com/in/limousin-pauline-1237632a5/?originalSubdomain=fr",
  },
];
